"use strict";
/**
 * The MakeUp module provides access to advanced content management features from the EVA back-end
 * @preferred
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var base_1 = require("./base");
var _ = require("lodash");
var xhr_1 = require("../xhr");
// MakeUp calls should never be cached
//
var disableServiceCache = true;
var MakeUp;
(function (MakeUp) {
    /**
     * Provides access to a make up content map
     */
    function getPageMap(languageID) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetPageMap");
        // Build the request data
        //
        var requestData = {
            LanguageID: languageID,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getPageMap = getPageMap;
    /**
     * Provides access to a make up content page by path
     */
    function getPageByRequestPath(path, languageID) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetPageByPath");
        // Build the request data
        //
        var requestData = {
            Path: path,
            LanguageID: languageID,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getPageByRequestPath = getPageByRequestPath;
    /**
     * Provides access to a make up content page by id
     */
    function getPageByID(ID, languageID, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetPageByID");
        // Build the request data
        //
        var requestData = {
            ID: ID,
            LanguageID: languageID,
            Version: version,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getPageByID = getPageByID;
    /**
     * Provides access to a rendered make up content page by path
     */
    function getRenderedPageByRequestPath(path, languageID) {
        // Create our service instance
        //
        var callURL = "/api/v1/makeup/page/path/rendered";
        var service = new service_1.EVAService("MakeupGetRenderedPageByPath", callURL, xhr_1.EXMLHttpRequestMethod.GET);
        // Build the request data
        //
        var requestData = {
            Path: path,
            LanguageID: languageID,
        };
        // Perform the call and capture the resulting promise
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function (result) {
                result.response.PathContext = {
                    Path: result.request.Path,
                    Parameters: []
                };
                var pathParams = _.map((result.xhr.getResponseHeader("EVA-Makeup-Path-Params") || "").split(","), decodeURIComponent);
                _.each(pathParams, function (pathParam) {
                    if (_.size(pathParam.split("=")) === 2) {
                        result.response.PathContext.Parameters.push({
                            Key: _.trim(_.get(pathParam.split("="), 0)),
                            Value: _.trim(_.get(pathParam.split("="), 1))
                        });
                    }
                });
                resolve(result);
            })
                .catch(reject);
        });
    }
    MakeUp.getRenderedPageByRequestPath = getRenderedPageByRequestPath;
    function getRenderedPagesByPartialPath(path, languageID) {
        // Create our service instance
        //
        var callURL = "/api/v1//makeup/page/partial_path/rendered";
        var service = new service_1.EVAService("MakeupGetRenderedPagesByPartialPath");
        // Build the request data
        //
        var requestData = {
            PartialPath: path,
            LanguageID: languageID,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getRenderedPagesByPartialPath = getRenderedPagesByPartialPath;
    /**
     * Provides access to a make up content page by id
     */
    function getRenderedPageByID(ID, languageID, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetRenderedPageByID");
        // Build the request data
        //
        var requestData = {
            ID: ID,
            LanguageID: languageID,
            Version: version,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getRenderedPageByID = getRenderedPageByID;
    /**
     * Provides access to create a new Makeup page
     * @param page The MakeupPageDto
     */
    function createPage(page) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupCreatePage");
        // Build the request data
        //
        var requestData = {
            Page: page,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function (response) {
                getPageByID(response.response.ID).then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    MakeUp.createPage = createPage;
    /**
     * Provides access to replace a MakeUp page
     * @param id   The ID of the Makeup page
     * @param page The MakeUpPageDto
     */
    function replacePage(page) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupReplacePage");
        // Build the request data
        //
        var requestData = {
            Page: page,
            ID: page.ID,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function () {
                getPageByID(requestData.ID).then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    MakeUp.replacePage = replacePage;
    /**
     * Convenience method to upsert a Makeup page
     * @param id   The ID of the Makeup page
     * @param page The MakeUpPageDto
     */
    function upsertPage(page) {
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            getPageByID(page.ID, page.LanguageID)
                .then(function (fetchResult) {
                var existingPage = fetchResult.response.Page;
                if (existingPage) {
                    // Page is an immutable object so first clone the damn thing
                    //
                    var payload = _.clone(page);
                    payload.ID = existingPage.ID;
                    replacePage(payload).then(resolve).catch(reject);
                }
                else {
                    createPage(page).then(resolve).catch(reject);
                }
            })
                .catch(reject);
        });
    }
    MakeUp.upsertPage = upsertPage;
    /**
     * Convenience method to retrieve the latest version of a makeup page
     * @param id The ID of the Makeup page
     * @param languageID The language
     */
    function getCurrentPageVersion(id, languageID) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetCurrentPageVersion");
        // Build the request data
        //
        var requestData = {
            ID: id,
            LanguageID: languageID,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache).then(resolve).catch(reject);
        });
    }
    MakeUp.getCurrentPageVersion = getCurrentPageVersion;
    /**
     * Convenience method to publish a version of a Makeup page
     * @param id The ID of the Makeup page
     * @param languageID The language
     */
    function publishPageVersion(id, languageID, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupPublishPageVersion");
        // Build the request data
        //
        var requestData = {
            ID: id,
            LanguageID: languageID,
            Version: version,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache).then(resolve).catch(reject);
        });
    }
    MakeUp.publishPageVersion = publishPageVersion;
    /**
     * Provides access to delete a Makeup page
     * @param id The ID of the Makeup page
     */
    function deletePage(id, languageID, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupDeletePage");
        // Build the request data
        //
        var requestData = {
            ID: id,
            LanguageID: languageID,
            Version: version,
        };
        // Build the request
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.deletePage = deletePage;
    /****************
     *    BLOCKS    *
     ****************/
    function getBlockByID(ID, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetBlockByID");
        // Build the request data
        //
        var requestData = {
            ID: ID,
            Version: version,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getBlockByID = getBlockByID;
    function getRenderedBlockByID(ID, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetRenderedBlockByID");
        // Build the request data
        //
        var requestData = {
            ID: ID,
            Version: version,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getRenderedBlockByID = getRenderedBlockByID;
    /**
     * Provides access to create a new Makeup block
     * @param block The BlockDto to create
     */
    function createBlock(block) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupCreateBlock");
        // Build the request data
        //
        var requestData = {
            Block: block,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function (response) {
                getBlockByID(response.response.ID).then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    MakeUp.createBlock = createBlock;
    /**
     * Convenience method to upsert a Makeup block
     * @param id    The ID of the Makeup block
     * @param block The MakeUpBlockDto
     */
    function upsertBlock(block) {
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            getBlockByID(block.ID)
                .then(function (fetchResult) {
                var existingBlock = fetchResult.response.Block;
                if (existingBlock) {
                    // Block is an immutable object so first clone the damn thing
                    //
                    var payload = _.clone(block);
                    payload.ID = existingBlock.ID;
                    replaceBlock(payload).then(resolve).catch(reject);
                }
                else {
                    createBlock(block).then(resolve).catch(reject);
                }
            })
                .catch(reject);
        });
    }
    MakeUp.upsertBlock = upsertBlock;
    /**
     * Provides access to replace a MakeUp block
     * @param block The BlockDto
     */
    function replaceBlock(block) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupUpdateBlock");
        // Build the request data
        //
        var requestData = {
            Block: block,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function (response) {
                getBlockByID(requestData.Block.ID).then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    MakeUp.replaceBlock = replaceBlock;
    /**
     * Provides access to delete a Makeup block
     * @param id The ID of the Makeup block
     */
    function deleteBlock(id, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupDeleteBlock");
        // Build the request data
        //
        var requestData = {
            ID: id,
            Version: version,
        };
        // Build the request
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.deleteBlock = deleteBlock;
    /**
     * Convenience method to retrieve the latest version of a makeup block
     * @param id The ID of the Makeup block
     */
    function getCurrentBlockVersion(id) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetCurrentBlockVersion");
        // Build the request data
        //
        var requestData = {
            ID: id,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache).then(resolve).catch(reject);
        });
    }
    MakeUp.getCurrentBlockVersion = getCurrentBlockVersion;
    /**
     * Convenience method to publish a version of a Makeup block
     * @param id The ID of the Makeup block
     * @param version The version to set
     */
    function publishBlockVersion(id, version) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupPublishBlockVersion");
        // Build the request data
        //
        var requestData = {
            ID: id,
            Version: version,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache).then(resolve).catch(reject);
        });
    }
    MakeUp.publishBlockVersion = publishBlockVersion;
    /****************
     *    MENU      *
     ****************/
    function getMenuByID(ID, languageID) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetMenuByID");
        // Build the request data
        //
        var requestData = {
            ID: ID,
            LanguageID: languageID,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getMenuByID = getMenuByID;
    /**
     * Provides access to create a new Makeup block
     * @param block The MenuDto to create
     */
    function createMenu(block) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupCreateMenu");
        // Build the request data
        //
        var requestData = {
            Menu: block,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function (response) {
                getMenuByID(response.response.ID).then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    MakeUp.createMenu = createMenu;
    /**
     * Convenience method to upsert a Makeup block
     * @param id    The ID of the Makeup block
     * @param block The MakeUpMenuDto
     */
    function upsertMenu(block) {
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            getMenuByID(block.ID)
                .then(function (fetchResult) {
                var existingMenu = fetchResult.response.Menu;
                if (existingMenu) {
                    // Page is an immutable object so first clone the damn thing
                    //
                    var payload = _.clone(block);
                    payload.ID = existingMenu.ID;
                    replaceMenu(payload).then(resolve).catch(reject);
                }
                else {
                    createMenu(block).then(resolve).catch(reject);
                }
            })
                .catch(reject);
        });
    }
    MakeUp.upsertMenu = upsertMenu;
    /**
     * Provides access to replace a MakeUp block
     * @param menu The MenuDto
     */
    function replaceMenu(menu) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupReplaceMenu");
        // Build the request data
        //
        var requestData = {
            ID: menu.ID,
            Menu: menu,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function (response) {
                getMenuByID(requestData.Menu.ID).then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    MakeUp.replaceMenu = replaceMenu;
    /**
     * Provides access to delete a Makeup block
     * @param id The ID of the Makeup block
     */
    function deleteMenu(id, languageID) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupDeleteMenu");
        // Build the request data
        //
        var requestData = {
            ID: id,
            LanguageID: languageID,
        };
        // Build the request
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.deleteMenu = deleteMenu;
    /****************************
     *    CONFIGURATION PROFILE *
     ****************************
     */
    function getConfigurationProfile(languageID) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetConfigurationProfile");
        // Build the request data
        //
        var requestData = {
            LanguageID: languageID,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getConfigurationProfile = getConfigurationProfile;
    /**
     * Provides access to replace a ConfigurationProfile
     * @param profile The ConfigurationProfile
     */
    function replaceConfigurationProfile(profile, languageID) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupReplaceConfigurationProfile");
        // Build the request data
        //
        var requestData = {
            Configuration: profile,
            LanguageID: languageID || profile.LanguageID,
        };
        // Build the request
        //
        return new Promise(function (resolve, reject) {
            service.call(requestData, disableServiceCache)
                .then(function (response) {
                getConfigurationProfile().then(resolve).catch(reject);
            })
                .catch(reject);
        });
    }
    MakeUp.replaceConfigurationProfile = replaceConfigurationProfile;
    /****************************
     * SITE CONFIGURATION       *
     ****************************
     */
    function replaceSiteConfigurationSchema(siteId, schema) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupReplaceSiteConfigurationSchema");
        // Build the request data
        //
        var requestData = {
            SiteID: siteId,
            Schema: schema,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.replaceSiteConfigurationSchema = replaceSiteConfigurationSchema;
    function replaceSiteConfiguration(siteId, languageID, configuration) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupReplaceSiteConfiguration");
        // Build the request data
        //
        var requestData = {
            SiteID: siteId,
            LanguageID: languageID,
            Configuration: configuration,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.replaceSiteConfiguration = replaceSiteConfiguration;
    function getSiteConfigurationSchema(siteId) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetSiteConfigurationSchema");
        // Build the request data
        //
        var requestData = {
            SiteID: siteId,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getSiteConfigurationSchema = getSiteConfigurationSchema;
    function getSiteConfiguration(siteId, languageId) {
        // Create our service instance
        //
        var service = new service_1.EVAService("MakeupGetSiteConfiguration");
        // Build the request data
        //
        var requestData = {
            SiteID: siteId,
            LanguageID: languageId,
        };
        // Perform the call and capture the resulting promise
        //
        return service.call(requestData, disableServiceCache);
    }
    MakeUp.getSiteConfiguration = getSiteConfiguration;
})(MakeUp = exports.MakeUp || (exports.MakeUp = {}));
var MakeupListPageVersions = /** @class */ (function (_super) {
    __extends(MakeupListPageVersions, _super);
    function MakeupListPageVersions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the current page identifier
     * @return {string}       The page identifier
     */
    MakeupListPageVersions.prototype.getPageID = function () {
        return this.page_id;
    };
    /**
     * Set the make up page identifier
     * @param  {string} page_id The page identifier
     * @return {string}         The currently page identifier
     */
    MakeupListPageVersions.prototype.setPageID = function (page_id) {
        return this.page_id = page_id;
    };
    /**
     * Set the make up page language
     * @param  {string} page_id The page language
     * @return {string}         The currently page language
     */
    MakeupListPageVersions.prototype.setLanguageID = function (languageID) {
        return this.languageID = languageID;
    };
    /**
     * Returns the current page language
     * @return {string}       The page language
     */
    MakeupListPageVersions.prototype.getLanguageID = function () {
        return this.languageID;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Makeup.MakeupListPageVersions, EVA.Makeup.MakeupListPageVersionsResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    MakeupListPageVersions.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            ID: this.page_id
        };
        if (this.languageID) {
            requestData.LanguageID = this.languageID;
        }
        // Apply PageConfig parameters directly
        //
        _.assign(requestData, _.omit(this.getPageConfiguration(), ["Filter"]));
        return _super.prototype.fetch.call(this, "MakeupListPageVersions", requestData, "/api/v1/makeup/page/" + requestData.ID + "/version_history", xhr_1.EXMLHttpRequestMethod.GET);
    };
    return MakeupListPageVersions;
}(base_1.FetchablePagedList));
exports.MakeupListPageVersions = MakeupListPageVersions;
var MakeupListBlocks = /** @class */ (function (_super) {
    __extends(MakeupListBlocks, _super);
    function MakeupListBlocks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the current requested block type
     * @return {string}       The block type
     */
    MakeupListBlocks.prototype.getType = function () {
        return this.type;
    };
    /**
     * Set the block type to retrieve
     * @param  {string} type The new block type
     * @return {string}       The currently set block type
     */
    MakeupListBlocks.prototype.setType = function (type) {
        return this.type = type;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Makeup.MakeupListBlocks, EVA.Makeup.MakeupListBlocksResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    MakeupListBlocks.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {};
        if (this.type) {
            requestData.Type = this.type;
        }
        // Apply PageConfig parameters directly
        //
        _.assign(requestData, _.omit(this.getPageConfiguration(), ["Filter"]));
        return _super.prototype.fetch.call(this, "MakeupListBlocks", requestData, "/api/v1/makeup/block", xhr_1.EXMLHttpRequestMethod.GET);
    };
    return MakeupListBlocks;
}(base_1.FetchablePagedList));
exports.MakeupListBlocks = MakeupListBlocks;
var MakeupListBlockVersions = /** @class */ (function (_super) {
    __extends(MakeupListBlockVersions, _super);
    function MakeupListBlockVersions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the current block identifier
     * @return {string}       The block identifier
     */
    MakeupListBlockVersions.prototype.getBlockID = function () {
        return this.block_id;
    };
    /**
     * Set the make up block identifier
     * @param  {string} block_id The block identifier
     * @return {string}         The currently block identifier
     */
    MakeupListBlockVersions.prototype.setBlockID = function (block_id) {
        return this.block_id = block_id;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Makeup.MakeupListBockVersions, EVA.Makeup.MakeupListBlockVersionsResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    MakeupListBlockVersions.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {
            ID: this.block_id
        };
        // Apply PageConfig parameters directly
        //
        _.assign(requestData, _.omit(this.getPageConfiguration(), ["Filter"]));
        return _super.prototype.fetch.call(this, "MakeupListBlockVersions", requestData, "/api/v1/makeup/block/" + requestData.ID + "/version_history", xhr_1.EXMLHttpRequestMethod.GET);
    };
    return MakeupListBlockVersions;
}(base_1.FetchablePagedList));
exports.MakeupListBlockVersions = MakeupListBlockVersions;
var MakeupListMenus = /** @class */ (function (_super) {
    __extends(MakeupListMenus, _super);
    function MakeupListMenus() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the current language identifier
     * @return {string} The language identifier
     */
    MakeupListMenus.prototype.getLanguageID = function () {
        return this.languageID;
    };
    /**
     * Set the language identifier
     * @param  {string} language The language identifier
     */
    MakeupListMenus.prototype.setLanguageID = function (languageID) {
        return this.languageID = languageID;
    };
    /**
     * Fetches the list of items
     * @return {Promise<IEVAServiceResponse<EVA.Makeup.MakeupListMenus, EVA.Makeup.MakeupListMenusResponse>>} A promise resolving when the fetch from the back-end has completed
     */
    MakeupListMenus.prototype.fetch = function () {
        // Build the request data
        //
        var requestData = {};
        // Set the optional language flag
        //
        if (this.languageID) {
            requestData.LanguageID = this.languageID;
        }
        // Apply PageConfig parameters directly
        //
        _.assign(requestData, _.omit(this.getPageConfiguration(), ["Filter"]));
        return _super.prototype.fetch.call(this, "MakeupListMenus", requestData, "/api/v1/makeup/menu", xhr_1.EXMLHttpRequestMethod.GET);
    };
    return MakeupListMenus;
}(base_1.FetchablePagedList));
exports.MakeupListMenus = MakeupListMenus;
